import React, { useContext, useEffect, useState } from "react";
import { useLocation } from "react-router-dom";

import styled from "styled-components/macro";

import { FlocknoteAppState } from "Flocknote/state";

import qs from "qs";

import Portal from "Utilities/PortalMaker";

import API from "./API";
import PledgeUser from "./PledgeUser";

export default function PledgeUserList() {
  const [pledges, setPledges] = useState([]);

  const [
    {
      networkGiving: { refreshPledgeUsers },
    },
  ] = useContext(FlocknoteAppState);

  const location = useLocation();
  const queryString = qs.parse(location.search, { ignoreQueryPrefix: true });

  const campaignID = queryString.campaignID;
  const dateType = queryString.date;
  const startDate = queryString.start ? queryString.start : null;
  const endDate = queryString.end ? queryString.end : null;

  useEffect(() => {
    if (!campaignID) return;

    const postData = {
      campaignID: campaignID,
      dateType: dateType,
    };
    if (startDate) {
      postData.startDate = startDate;
    }
    if (endDate) {
      postData.endDate = endDate;
    }

    const getPledgeCall = API.getPledges(postData);

    getPledgeCall
      .get()
      .then((res) => {
        setPledges(res.pledges);
      })
      .catch((err) => console.log("getPledgesCall", err));

    return () => getPledgeCall.cancel();
  }, [campaignID, refreshPledgeUsers, dateType, endDate, startDate]);

  if (!campaignID) return null;

  const givingColumnRight = document.querySelector(
    ".network_giving_column_right .network_giving_column_inside"
  );

  if (!givingColumnRight) return null;

  return (
    <Portal to={givingColumnRight}>
      <Wrapper className={pledges.length === 0 && "loading"}>
        <Header>
          <Title>Pledges</Title>
          <Description>
            Below is a list of pledges that your members have made. Click on one
            to open their giving profile.
          </Description>
        </Header>
        <PledgesHolder>
          {pledges.map((pledge) => (
            <PledgeUser key={pledge.ID} {...pledge} />
          ))}
        </PledgesHolder>
      </Wrapper>
    </Portal>
  );
}

const Wrapper = styled.div`
  border-left: 1px solid #d4d9db;
  height: 100%;
  box-sizing: border-box;
  transition: transform 0.4s, opacity 0.4s;
  display: flex;
  flex-direction: column;

  .loading &,
  &.loading {
    transform: translateX(100%);
    opacity: 0;
  }

  @media screen and (max-width: 1200px) and (min-width: 841px),
    screen and (max-width: 720px) {
    background: #fff;
    border-radius: 10px;
    max-width: 620px;
    margin: 0 auto;
    margin-bottom: 120px;
    border: 1px solid #d4d9db;
    overflow: hidden;
  }
`;

const Header = styled.div`
  padding: 12px;
  @media screen and (min-width: 1521px) {
    flex-grow: 0;
    flex-shrink: 0;
  }
`;
const Title = styled.div`
  font-size: 20px;
  font-weight: 400;
  margin-bottom: 6px;
`;
const PledgesHolder = styled.div`
  @media screen and (min-width: 1521px) {
    flex-grow: 1;
    overflow: auto;
  }
`;
const Description = styled.div`
  font-size: 14px;
  color: #828c8d;
`;
